import Backbone from 'backbone'
import $ from 'jquery'
import _ from 'lodash'
import constants from 'scoreboard/components/constants'

const InlineTextInput = Backbone.View.extend({

	className: 'inline-text-input',

	/**
	 * @constructs a simple inline textbox for editing text filters
	 *
	 * @param {Object} options
	 *
	 * @param {Object} options.filter the filter to be used for editing. Will
	 * not be mutated
	 */
	initialize(options = {}) {
		this.options = options
		this.filter = options.filter
	},

	render: function () {
		let initial = _.get(this.filter, 'values[0]', '')
		let input = $(`<input type="text" value="${initial}">`)
		this.$el.append(input)

		// Debounce change handlers so we don't fire a dataset query every time
		// the user types a letter
		let onInput = _.debounce(() => {
			this.trigger('change')
		}, constants.SEARCH_DELAY)

		input.on('input', onInput)

		input.focus()
		input[0].setSelectionRange(initial.length, initial.length)

		input.on('blur', () => this.trigger('done'))

		this.$el
			.width(this.$el.width()) // Have to set a fixed width so SCSS can transition correctly
			.addClass('is-expanded')

		return this
	},

	val: function () {
		return this.$('input').val()
	}
})

export default InlineTextInput

InlineTextInput.__filename__ = 'dashboards/widgets/dataset-filter/inline-text-input.js'
